// extracted by mini-css-extract-plugin
export var brand = "_1m-8";
export var compact = "_1m-5";
export var extraSmall = "_1m-6";
export var icon = "_1m-0";
export var large = "_1m-3";
export var light = "_1m-1";
export var medium = "_1m-4";
export var outline = "_1m-a";
export var primaryDark = "_1m-9";
export var primaryLight = "_1m-7";
export var primaryModern = "_1m-b";
export var success = "_1m-2";